import React from 'react';
import './SearchTypeToolTip.styl';
import GenericTooltip from 'components/pure/tooltips/GenericTooltip';
import {CallToAction} from 'components/pure/tooltips/CallToAction';
import GenericLink from 'components/GenericLink';

/**
 * Tooltip with a CTA to guide the user to phone search
 */
export default class SearchTypeToolTip extends React.Component {
  render() {
    return (
      <GenericTooltip
        className={'phone-search-cta'}
        open
        tooltip={
          <CallToAction
            dismissible
            onDismiss={this.props.onDismiss}
            text={
              <div>
                <p>
                  It looks like you're entering a phone number.{' '}
                  <GenericLink onClick={this.props.onOpenPhoneSearch}>Click here </GenericLink>
                  to search for formatted phone numbers.
                </p>
                <p>
                  (In the future, you can get to the phone number search by clicking on the search
                  icon at the left of the search field or from Advanced Search.)
                </p>
              </div>
            }
          />
        }
      />
    );
  }
}
